<template>
<div class="ma-0 pa-0">
  <app-modal-row class="justify-center mb-4">
    <v-icon
      size="55"
      color="primary"
    >{{titleIcon}}</v-icon>
  </app-modal-row>
  <app-modal-row v-if="showTitle && textTitle" class="justify-center mb-4">
    <h3 class="black--text app-confirm-modal__title">{{ textTitle }}</h3>
  </app-modal-row>
</div>
</template>

<script>
import AppModalRow from '@/components/layout/AppModalRow.vue';

export default {
  name: 'AppConfirmModalTitle',

  components: {
    AppModalRow
  },

  props: {
    titleIcon: {
      type: String,
      default: 'mdi-alert-outline'
    },
    showTitle: {
      type: Boolean,
      default: false
    },
    textTitle: {
      type: String,
      default: ''  
    },
  }
}
</script>

<style scoped>
.app-confirm-modal__title {
  font-family: 'Roboto';
  font-style: normal;
  font-size: 20px;
  line-height: 23px;
  font-weight: 700;
  text-align: center;
}
</style>